module.exports = __webpack_public_path__ + "img/119.b2ed3e6.jpg";